import ArtifactGroupType from "../base/ArtifactGroupType";


const ArabianOstrichEggContainer = {
  id: '153',
  name: 'Arabian Ostrich Egg Container',
  groupIcon: 'PathsOfIncense',
  type: ArtifactGroupType.PATH_OF_INCENSE,
  icon: 'ArabianOstrichEggContainer',
  power: 10
};

export default ArabianOstrichEggContainer;
